import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Wrapper, ContentContainer, TitleText, DescriptionText, ItemWrap } from './SublimitHomeCareList.style';
import Placeholder from '../../../components/Placeholder';
import SublimicHomeCareListSection from './SublimicHomeCareListSection/SublimicHomeCareListSection';
import { homeCareItemFilter } from '../../../utils';

class SublimicHomeCareListPage extends React.Component {
  state = {};
  render() {
    const { locale, copy, authSalonSettingData } = this.props;
    const { title, description, hairCareLabelText, scalpCareLabelText, hairAndScalpCareLabelText } = copy;
    const { hairItems, scalpItems, hairAndScalpItems } = homeCareItemFilter(copy, authSalonSettingData);
    const isFetched = Object.keys(authSalonSettingData).length;

    return (
      <Wrapper>
        <ContentContainer>
          <TitleText>{title || <Placeholder w="149px" h="35px" />}</TitleText>
          <DescriptionText>{description || <Placeholder w={['300px', '492px']} h="25px" />}</DescriptionText>
          <ItemWrap>
            {/* PromotionText付きのリスト */}
            {isFetched ? (
              hairItems &&
              hairItems
                .filter(({ promotionText }) => promotionText)
                .map((item, index) => (
                <SublimicHomeCareListSection
                  locale={locale}
                  labelText={hairCareLabelText}
                  item={item}
                  i={index}
                  key={item.entryId}
                />
              ))
            ) : (
              <Placeholder w={['100%', '728px']} h="224px" m="0 0 10px 0" />
            )}
            {isFetched ? (
              scalpItems &&
              scalpItems
                .filter(({ promotionText }) => promotionText)
                .map((item, index) => (
                <SublimicHomeCareListSection
                  locale={locale}
                  labelText={scalpCareLabelText}
                  item={item}
                  i={index}
                  key={item.entryId}
                />
              ))
            ) : (
              <Placeholder w={['100%', '728px']} h="224px" m="0 0 10px 0" />
            )}
            {isFetched ? (
              hairAndScalpItems &&
              hairAndScalpItems
                .filter(({ promotionText }) => promotionText)
                .map((item, index) => (
                <SublimicHomeCareListSection
                  locale={locale}
                  labelText={hairAndScalpCareLabelText}
                  item={item}
                  i={index}
                  key={item.entryId}
                  isHairAndScalp
                />
              ))
            ) : (
              <Placeholder w={['100%', '728px']} h="224px" />
            )}
            {/* PromotionText無しのリスト */}
            {hairItems && (
              hairItems.filter(({ promotionText }) => !promotionText).map((item, index) => (
                <SublimicHomeCareListSection
                  locale={locale}
                  labelText={hairCareLabelText}
                  item={item}
                  i={index}
                  key={item.entryId}
                />
              ))
            )}
            {scalpItems && (
              scalpItems.filter(({ promotionText }) => !promotionText).map((item, index) => (
                <SublimicHomeCareListSection
                  locale={locale}
                  labelText={scalpCareLabelText}
                  item={item}
                  i={index}
                  key={item.entryId}
                />
              ))
            )}
            {hairAndScalpItems && (
              hairAndScalpItems.filter(({ promotionText }) => !promotionText).map((item, index) => (
                <SublimicHomeCareListSection
                  locale={locale}
                  labelText={hairAndScalpCareLabelText}
                  item={item}
                  i={index}
                  key={item.entryId}
                  isHairAndScalp
                />
              ))
            )}
          </ItemWrap>
        </ContentContainer>
      </Wrapper>
    );
  }
}

SublimicHomeCareListPage.defaultProps = {
  copy: {},
  authSalonSettingData: {},
};
SublimicHomeCareListPage.propTypes = {
  copy: PropTypes.shape({}),
  locale: PropTypes.string.isRequired,
  authSalonSettingData: PropTypes.shape({}),
};
const mapState = state => ({
  copy: state.homeCareItemList,
  locale: state.locale,
  authSalonSettingData: state.authSalonSettings,
});

export default connect(mapState)(SublimicHomeCareListPage);



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicHomeCareList/SublimicHomeCareList.js